import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactService } from '../../services/contact/contact.service';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contactenos',
  templateUrl: './contactenos.component.html',
  styleUrls: ['./contactenos.component.scss']
})
export class ContactenosComponent implements OnInit {
 
  dataContact : FormGroup; 
  RE_CAPTCHA_KEY = environment.RE_CAPTCHA_KEY;
  public next: boolean = false;
  public token: string | undefined;
  public tokenIsReceived: boolean = false;
  public buttonDisabled: boolean = true;
  public setTimeout: any = "";
  public scrollTop: number = 0;
  fb: FormBuilder;

  constructor(
    public dialogRef: MatDialogRef<ContactenosComponent>,
    private contactService: ContactService,
    private toastrService: ToastrService
  ) {
    
   }

  ngOnInit(): void {
    this.dataContact= new FormGroup({
      name: new FormControl('',Validators.compose([Validators.required, Validators.pattern('^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$')])),
      email : new FormControl('',Validators.compose([Validators.required, Validators.max(254), Validators.pattern('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$')])),
      bcc :new FormControl(false),
      message : new FormControl('',Validators.compose([Validators.required, Validators.pattern('^[A-Za-zÁÉÍÓÚáéíóúñÑ0123456789 ,.;]+$')])),
      
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  send() {

    this.contactService.sendContactInfo(this.dataContact.get('name')?.value, this.dataContact.get('email')?.value, this.dataContact.get('message')?.value, this.dataContact.get('bcc')?.value, this.token, 'Desde el inicio')
      .pipe()
      .subscribe(response => {
        // @ts-ignore
        if (response.success) {
          console.log('consume bn el servicio');
          
          // @ts-ignore
          this.toastrService.show(response.message, null, {
            closeButton: true,
            disableTimeOut: true,
            positionClass: 'toast-top-full-width'
          });
          this.dialogRef.close();
        }
      });
  }

  public showErrorMessage() {
    this.toastrService.show("Se produjo un error al intentar contactar al asesor", undefined, {
      timeOut: 4000,
      positionClass: 'toast-top-full-width',
      toastClass: 'toast-error',
      messageClass: 'message'
    });
    this.dialogRef.close();
  }

  resolved(captchaResponse: string) {
    if (captchaResponse) {
      this.contactService.getTimeToken()
      .pipe()
      .subscribe(response => {
        // @ts-ignore
        if (response.success) {
          // @ts-ignore
          this.token = response.token;
          this.tokenIsReceived = true;
          this.buttonDisabled = false;
        } else {
          this.tokenIsReceived = false;
          this.buttonDisabled = true;
          this.showErrorMessage();
        }
      });
    }
  }

  buttonEnviarForm(){
    if(this.tokenIsReceived){
      this.send();
    }
  }
}
